<template>
<div class="container home-wrap">
  <div class="container home-container display_flex"
       :style="{
    'background':'url('+background+')'
  }"
  >
    <div class="logo-container">
      <img src="./images/logo.png" class="logo" />
    </div>
    <div class="display_flex_1 flex_aCenter home-content">
      <img :src="title" class="image_title" />
      <div class="input-container flex_row flex_center">
        <div class="input-item"
             v-for="(item,index) in inputData"
             :key="index"
        >
          <div class="input-label">{{item.label}}</div>
          <div class="input-target">
            <input
                :placeholder="item.placeholder"
                v-model="item.value"
                :ref="item.key"
                :type="mobile ? item.type : 'text'"
            />
          </div>
        </div>
      </div>
      <div @click="submit"
           :class="{'button-disabled':loading}"
           class="button home-button button-active flex_center">Login</div>
    </div>
  </div>
</div>
</template>

<script>
import inputData from './data/input';
import { message } from 'ant-design-vue';
import axios from 'axios';
import storage from "@/utils/storage";
export default {
  name: "home",
  data(){
    return {
      background_pc: require('./images/background.png'),
      background_mobile: require('./images/background-mobile.png'),
      title_pc: require('./images/title.png'),
      title_mobile: require('./images/mobile.png'),
      inputData,
      mobile:false,
      loading:false
    }
  },
  computed:{
    title(){
      return this.mobile ? this.title_mobile:this.title_pc;
    },
    background(){
      return this.mobile ? this.background_mobile:this.background_pc;
    }
  },
  methods:{
    watchMobile(config){
      this.mobile = config.realWidth <= 768
    },
    submit(){
      let next =true;
      let object = {};
      this.inputData.map((item)=>{

        if(next && !item.value) {
          next = false;
          if (this.$refs[item.key] && this.$refs[item.key][0]) {
            this.$refs[item.key][0].focus();
          }
          return message.info(item.tip || item.placeholder);
        } else {
          object[item.key] = item.value;
        }

      });
      if(next) {
        this.loading=true;
        axios({
          url:'https://bizconfstreaming.yunkust.com/index/index/unitedimaging_data',
          data:object,
          method:'post'
        }).then((data)=>{
          data =data.data;
          if(data.code === 1) {
            storage.setItem('info',data,7 * 24 * 60 * 60);
            return  this.goLogin(data);
          } else {
            return message.info(data.msg);
          }
        }).finally(()=>{
          this.loading = false;
        })
      }
    },
    goLogin(data){
      return location.href = data.data;
    }
  },
  created() {

    let data = storage.getItem('info');

    if(data){
      return this.goLogin(data);
    }
    message.config({
      top: `30px`,
      duration: 2,
      maxCount: 3,
    });

    observer_size.push( (config)=>{
      this.watchMobile(config);
    });
    this.watchMobile(screen_conf);
  }
}
</script>

<style scoped src="./style.scss" lang="scss">

</style>
